import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

/**
 * The signed-in area.
 *
 * The guard lives on the layout route so every child inherits it — a new page
 * under `/dashboard` is protected by existing, which is the only kind of
 * auth check that does not eventually get forgotten.
 *
 * This is a redirect for the user's benefit, not a security control: the server
 * authorises every procedure independently, and a hand-crafted request that
 * skips the UI gets nowhere.
 */
export const Route = createFileRoute("/dashboard")({
	beforeLoad: async ({ context, location }) => {
		const session = await context.queryClient.ensureQueryData(
			context.trpc.session.queryOptions(),
		);

		if (session.user === null) {
			throw redirect({
				to: "/sign-in",
				search: { redirect: location.href },
			});
		}

		// Made available to every child route's `beforeLoad` and `loader`.
		return { session };
	},

	// Every screen below needs the membership list — the switcher renders it on
	// all of them — so it is fetched once here rather than by each of them.
	loader: ({ context }) =>
		context.queryClient.ensureQueryData(
			context.trpc.businesses.mine.queryOptions(),
		),

	component: () => <Outlet />,
});
